import { useState } from 'react';
import axios from 'axios';
import { base_url } from '../apiConfig';

export function useFetchAuditstores() {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const getApiData = async (url) => {
        setIsLoading(true);
        try {
            const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/`;
            const token = localStorage.getItem("authToken");

            const response = await axios.get(fullUrl + url,{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`,
                },
            });
            setData(response.data);
        } catch (error) {
            console.log('An error occurred while fetching the API:', error);
            setError(error.response?.statusText || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    return { data, setData, isLoading, error, getApiData };
}

export function useFetchReportAttributes() {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const getApiData = async (url) => {
        setIsLoading(true);
        try {
            const fullUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/`;
            const token = localStorage.getItem("authToken");

            const response = await axios.get(fullUrl + url,{
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`,
                },
            });
            setData(response.data);
        } catch (error) {
            console.log('An error occurred while fetching the API:', error);
            setError(error.response?.statusText || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    return { data, setData, isLoading, error, getApiData };
}